import styled from "styled-components";

export const PopupContainer = styled.div`
    align-items: center;
    background: hsl(0 0% 0% / 30%);
    display: ${({$Active}) => ($Active ? 'flex' : 'none')};
    height: 100vh;
    justify-content: center;
    position: fixed;
    transition: ease-out 0.8s;
    width: 100%;
    z-index: 9999;

    h2{
        background: #F6F6F6;
        box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        color: #333;
        font-size: 20px;
        font-weight: 700;
        padding: 10px 0;
        text-align: center;
    }

    div.content{
        background: #FFF;
        border-radius: 10px;
        box-shadow: 1.461px 1.461px 0px 0px rgba(0, 0, 0, 0.25);
        display: flex;
        flex-direction: column;
        height: 70%;
        padding: 30px;
        position: relative;
        width: 90%;

        @media (min-width: 720px) {
            height: 63%;
            min-width: 385px;
            position: fixed;
            width: 22%;
        }
        @media (orientation: landscape) and (max-width: 1080px){
            height: 70%;
            width: 40%;
        }
    }

    div.childs-container{
        align-items: center;
        display: flex;
        flex-direction: column;
        height: 100%;
        margin-top: 20px;
        overflow: auto;
        width: 100%;
        &::-webkit-scrollbar {
            width : 7px;
        }
        &::-webkit-scrollbar-thumb {
            background: #ccc;
            border-radius: 5px;
        }
        &::-webkit-scrollbar-thumb:hover {
            background-color: #aaa
        }
        &::-webkit-scrollbar-track {
            background: transparent;
        }
        &::-webkit-scrollbar-button {
            display: none;
        }
    }
`;

